import React, { ChangeEvent } from "react";
import { Wrapper, FilterContainer } from "./style";
import { exportCSV } from "../../utils";
import Search from "../../../common/Search";
import Export from "../../../common/Export";

const TitleFilter = ({ search, setSearch, rates }: {
  search: string;
  setSearch: (val: string) => void;
  rates: any;
}) => {

  return (
     <Wrapper>
      <h1>Our rates</h1>
      
      <FilterContainer>
        <Search
          value={search}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
        />

        <Export
          downloadCSV={() => exportCSV(rates)}
          downloadXLS={() => exportCSV(rates)}
        />
      </FilterContainer>
    </Wrapper>
  );
};

export default TitleFilter;
